import React, { Component } from "react";
import DailyMenu from "../../assets/components/DailyMenu/DailyMenu";

class Menu extends Component {
  render() {
    return <DailyMenu />;
  }
}

export default Menu;
